import { Link } from "react-router-dom";
import SectionTitle from "@/components/base/SectionTitle";
import { archiveEntries } from "@/mocks/archive";

const typeColor: Record<string, string> = {
  anime: "bg-primary-100 text-primary-800",
  manga: "bg-accent-100 text-accent-900",
  game: "bg-secondary-100 text-secondary-800",
  novel: "bg-primary-100 text-primary-800",
  voice: "bg-accent-100 text-accent-900",
  fanwork: "bg-secondary-100 text-secondary-800",
};

export default function LatestArchive() {
  const latest = archiveEntries.slice(0, 6);

  return (
    <section className="bg-background-50">
      <div className="container-site py-14 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <SectionTitle
              eyebrow="最新归档"
              title="最近补全的整理贴"
              desc="归档页持续更新补全的目录记录，按系列与作者归类，想批量收藏直接查归档列表即可。"
            />
            <div className="hidden rounded-lg border border-background-200/70 bg-background-100/70 p-6 lg:block">
              <p className="font-heading text-lg font-bold text-foreground-900">
                归档小贴士
              </p>
              <p className="mt-3 text-sm leading-6 text-foreground-600">
                归档列表把资源按「作者归档、系列归档、作品归档」等维度归类。当你有了明确收藏目标，直接按对应分组筛选，就能快速找到完整目录，省去零散收藏的麻烦。
              </p>
              <Link
                to="/archive"
                className="btn-outline mt-5"
              >
                进入归档索引
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="flex flex-col divide-y divide-background-200/70 rounded-lg border border-background-200/70 bg-background-50">
              {latest.map((entry) => (
                <Link
                  key={entry.id}
                  to="/archive"
                  className="group flex items-center gap-4 px-5 py-4 transition-colors hover:bg-background-100/60"
                >
                  <span
                    className={`inline-flex shrink-0 items-center rounded-md px-2.5 py-1 text-xs font-medium ${typeColor[entry.typeKey] ?? "bg-background-200 text-foreground-700"}`}
                  >
                    {entry.type}
                  </span>
                  <div className="min-w-0 flex-1">
                    <h4 className="truncate text-sm font-medium text-foreground-800 transition-colors group-hover:text-primary-700 md:text-base">
                      {entry.title}
                    </h4>
                    <p className="mt-0.5 truncate text-xs text-foreground-500">
                      {entry.desc}
                    </p>
                  </div>
                  <div className="hidden shrink-0 flex-col items-end gap-1 sm:flex">
                    <span className="text-xs text-foreground-500">{entry.date}</span>
                    <span className="text-xs text-secondary-700">{entry.groupBy}</span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}